module.exports = __webpack_public_path__ + "static/media/volume.08e4d0fb.svg";